import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import "../userDashboard.css";
import SubscriptionPayment from "../../../components/userProfileComp/User-Subcription-Form";
import CategorySelection from "../../../components/sharedcomponents/CategorySelector";
import PaymentOnboarding from "../../../components/sharedcomponents/PaymentOnboarding";
import PaymentCardDetails from "../../../components/sharedcomponents/PaymentCardDetails";

export const UserSubscriptionPage = () => {
  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <TopBar
          showBackButton
          displayType="title"
          title="Subscription"
          showNotification
        ></TopBar>
        <SubscriptionPayment></SubscriptionPayment>
        {/* <CategorySelection></CategorySelection> */}
        {/* <PaymentOnboarding></PaymentOnboarding> */}
        {/* <PaymentCardDetails></PaymentCardDetails> */}
      </div>
    </>
  );
};

export default UserSubscriptionPage;
